import {createSlice} from '@reduxjs/toolkit'
import Segment from '../../../configs/prospectsSegmentTabList.json'

export const selectedProspectsTab = createSlice({
  name: 'prospectSegment',
  initialState: {
    value: Segment.segments.allProspects.key
  },
  reducers: {
    selectedTab: (state, action) => {
      state.value = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const {selectedTab} = selectedProspectsTab.actions

export default selectedProspectsTab.reducer
